import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-m-cities',
  templateUrl: './add-m-cities.component.html',
  styleUrls: ['./add-m-cities.component.scss']
})
export class AddMCitiesComponent implements OnInit {

 
 
    
         productId: string | null = null;
     
     
        JobTitleId: string | null = null;
     
       formData: any = {
        name_ar: '',
        name_en: '',
         country_id: ''
       };
     
      //  jobTitles = [
      //    { id: 1, name: 'Software Engineer' },
      //    { id: 2, name: 'Project Manager' },
      //    { id: 3, name: 'UI/UX Designer' }
      //  ];
      jobTitle: any;
  countries: any;
     
     
     constructor(
         private route: ActivatedRoute,
         private router: Router,
         private apiService: ApisService,
         private toastr: ToastrService,
          private translate: TranslateService
       ) {}
         ngOnInit(): void {
         // get product id from route
         this. getCountries();
        // this.JobTitleId = this.route.snapshot.paramMap.get('id');
       
     
             
       }
     
     
     
     
      //    onFileSelected(event: any): void {
      //    if (event.target.files.length > 0) {
      //      this.jobTitles.image = event.target.files[0];
      //    }
      //  }
       // Update product
       getCountries(){
       this.apiService.getCountriesM().subscribe({ 
      next:(response:any)=> { 
        this.countries = response.data || [] ;
        console.log('response from countries ' , this.countries)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
    }
     
    onSubmit(): void {
      const form = new FormData();
      form.append('name_en', this.formData.name_en);
      form.append('name_ar', this.formData.name_ar);
      form.append('country_id', this.formData.country_id);
      
      this.apiService.addCitiesM(form).subscribe({
        next: () => {
          this.toastr.success(this.translate.instant('MENU.DASHBOARD.cities_added_successfully'));
          this.router.navigate(['/m-cities']);
        },
        error: (err) => {
          console.error('Add cities failed:', err);
          this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_add_cities'));
        }
      });
    }
    
     
     cancel(): void {
        this.router.navigate(['/m-cities']);
      }
    
}
